export const selectUnmaskViewerScope = (snapshot: {
  context: {
    userId?: string;
    userInfoId?: number;
    employerUserId?: number;
    providerId?: number;
    roleCode?: string;
  };
}) =>
  [
    snapshot.context.userId,
    snapshot.context.userInfoId,
    snapshot.context.employerUserId,
    snapshot.context.providerId,
    snapshot.context.roleCode,
  ].join(':');
